// constants/sourceCategoryIcons.tsx

export const categoryIcons = {
  newspapers: (
    <i className="ri-file-list-3-fill text-brand-500 text-[18px]"></i>
  ),
  broadsheet: (
    <i className="ri-file-list-3-fill text-brand-500 text-[18px]"></i>
  ),
  tabloids: <i className="ri-file-list-3-fill text-brand-500 text-[18px]"></i>,
  provincial: (
    <i className="ri-file-list-3-fill text-brand-500 text-[18px]"></i>
  ),
  magazines: <i className="ri-file-list-3-fill text-brand-500 text-[18px]"></i>,
  "tv-channels": <i className="ri-tv-fill text-brand-500 text-[18px]"></i>,
  "am-radio": <i className="ri-radio-fill text-brand-500 text-[18px]"></i>,
  "fm-radio": <i className="ri-radio-fill text-brand-500 text-[18px]"></i>,
  "social-media": <i className="ri-global-fill text-brand-500 text-[18px]"></i>,
};
